module.exports = __webpack_public_path__ + "static/media/community2_800x500.b899489e.jpg";